import * as React from "react";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  MbjButton,
  MbjFlex,
  MbjLoading,
  MbjNavPath,
  MbjScrollArea,
  MbjWidgetClassic,
  useModal,
} from "@mbj-front-monorepo/ui";
import styled from "styled-components";
import { MessageItemCard } from "../MessageItemCard/MessageItemCard";
import { NouveauMessageModal } from "../NouveauMessageModal/NouveauMessageModal";
import { useGetMessagesInbox } from "@mbj-front-monorepo/data-access";
import { GoPlus } from "react-icons/go";

interface BoiteReceptionCtrlProps {
  className?: string;
}

function BoiteReceptionCtrl(props: BoiteReceptionCtrlProps) {
  const location = useLocation();
  const messagesInboxQuery = useGetMessagesInbox();

  const defaultVisible = !!location.state;

  const { isShowing: isShowing, toggle: toggle } = useModal(defaultVisible);

  const messagesFiltered = useMemo(() => {
    if (messagesInboxQuery === undefined || messagesInboxQuery.data === null || messagesInboxQuery.data === undefined) {
      return [];
    }
    return messagesInboxQuery.data?.filter((message) => !message.isTrashTo && !message.isVeryTrashTo);
  }, [messagesInboxQuery.data]);

  return (
    <div className={"BoiteReception " + props.className}>
      <div className={"top-container"}>
        <MbjNavPath routePath={location.pathname} />
        <MbjButton onClick={toggle} leftIcon={<GoPlus />}>
          Nouveau message
        </MbjButton>
        <NouveauMessageModal isShowing={isShowing} hide={toggle} />
      </div>
      <MbjWidgetClassic bodyDirection={"column"} title={"Boîte de réception"}>
        {messagesInboxQuery.isLoading ? (
          <MbjLoading />
        ) : messagesInboxQuery.isError ? (
          <p>Erreur ...</p>
        ) : messagesFiltered.length >= 0 ? (
          <>
            <div>
              {messagesFiltered.length + " " + (messagesFiltered.length === 1 ? "message reçu" : "messages reçus")}
            </div>
            <MbjScrollArea maxHeight={"550px"}>
              <MbjFlex direction={"column"} gap={"12px"}>
                {messagesFiltered.map((message, idx) => (
                  <MessageItemCard type="inbox" message={message} key={message.id} />
                ))}
              </MbjFlex>
            </MbjScrollArea>
          </>
        ) : (
          <div>Aucun message envoyé...</div>
        )}
      </MbjWidgetClassic>
    </div>
  );
}
export const BoiteReception = styled(BoiteReceptionCtrl)((props) => ({
  padding: "1% 2%",

  ".top-container": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));
